

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import Select from 'react-select';
import 'react-phone-input-2/lib/style.css';
import FlagSelect from 'react-flags-select';
import APIEndPoints from '../middleware/APIEndPoints.js';
import {Toaster, toast} from 'react-hot-toast';

const WorkWithMe = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    service: '',
    companyName: '',
    companyAddress: '',
    message: ''
  });

  const baseUrl = APIEndPoints.services.url;
  const baseUrlWorkWithMe = APIEndPoints.workwithme.url;

  const [services, setServices] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    // Fetch services from the backend
    const fetchServices = async () => {
      try {
        const response = await axios.get(baseUrl);
        const serviceOptions = response.data.map(service => ({
          value: service._id,
          label: service.name
        }));
        setServices(serviceOptions);
      } catch (error) {
        console.error('Error fetching services:', error);
      }
    };

    fetchServices();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleSelectChange = (selectedOption, name) => {
    setFormData(prevData => ({ ...prevData, [name]: selectedOption.value }));
  };

  const handleCountryChange = (countryCode) => {
    setFormData(prevData => ({ ...prevData, country: countryCode }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(baseUrlWorkWithMe, formData);
      console.log('Form submitted successfully:', response.data);
      toast.success('Submit Success!!')
      // Clear the form
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        service: '',
        companyName: '',
        companyAddress: '',
        message: ''
      });
    } catch (error) {
      setError('Error submitting the form. Please try again.');
      console.error('Error:', error);
      toast.error("Error while submitting")
    }
  };


  

  return (
    <div className="p-4">
      <Toaster />
      <div className="flex flex-col md:flex-row justify-around items-center shadow-lg rounded-lg mt-10 p-8 bg-[#1d0c39] text-gray-200">
        
        {/* Intro Section */}
        {/* <div className="md:w-1/3 text-center md:text-left mb-6 md:mb-0">
          <h4 className="text-3xl uppercase text-accent font-bold mb-4 tracking-wider">
            Hire Me
          </h4>
          <p className="text-lg">
            I am passionate about delivering high-quality work that meets your
            needs. My expertise ensures top-notch results for your projects.
          </p>
        </div> */}

        {/* Form Section */}
        <div className="md:w-2/3 bg-[#2a1a4a] p-8 rounded-lg shadow-md">
          <h2 className="text-2xl font-semibold mb-5 text-center text-accent">
            Work With Me
          </h2>
          {error && <p className="text-red-500 mb-4">{error}</p>}
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="First Name"
                required
                className="border border-gray-500 bg-[#3a2c5c] p-3 rounded-md w-full text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Last Name"
                required
                className="border border-gray-500 bg-[#3a2c5c] p-3 rounded-md w-full text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
            <div>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Email"
                required
                className="border border-gray-500 bg-[#3a2c5c] p-3 rounded-md w-full text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
            <div >
              <PhoneInput
                country={"np"}
                value={formData.phone}
                onChange={(phone) => setFormData({ ...formData, phone })}
                inputStyle={{
                  border: "1px solid gray",
                  borderRadius: "0.375rem",
                  width: "100%",
                  backgroundColor: "#3a2c5c",
                }}
                containerStyle={{ width: "100%" }}
                required
              />
            </div>
            <div className='text-white'>
              <FlagSelect
                selected={formData.country}
                onSelect={handleCountryChange}
                selectedSize={16}
                optionsSize={16}
                defaultCountry="NP"
                showSelectedLabel={true}
                showOptionLabel={true}
                className="w-full border border-gray-500 bg-[#3a2c5c] rounded-md p-3 text-black  focus:outline-none focus:ring-2 focus:ring-cyan-400"
                searchable
                searchPlaceholder="Search your country"
              />
            </div>
            <div>
              <Select
                options={services}
                onChange={(selectedOption) => handleSelectChange(selectedOption, "service")}
                placeholder="Select Service"
                className="text-black focus:outline-none focus:ring-2 focus:ring-cyan-400"
                styles={{
                  control: (base) => ({
                    ...base,
                    backgroundColor: "#3a2c5c",
                    border: "1px solid gray",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "white",
                  }),
                }}
                required
              />
            </div>
            <div>
              <input
                type="text"
                name="companyName"
                value={formData.companyName}
                onChange={handleChange}
                placeholder="Company Name"
                required
                className="border border-gray-500 bg-[#3a2c5c] p-3 rounded-md w-full text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
            <div>
              <input
                type="text"
                name="companyAddress"
                value={formData.companyAddress}
                onChange={handleChange}
                placeholder="Company Address"
                required
                className="border border-gray-500 bg-[#3a2c5c] p-3 rounded-md w-full text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
            <div>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Message"
                required
                className="border border-gray-500 bg-[#3a2c5c] p-3 rounded-md w-full text-gray-200 focus:outline-none focus:ring-2 focus:ring-cyan-400"
              />
            </div>
            <button
              type="submit"
              className="bg-accent/80 text-[#1d0c39] py-3 px-6 rounded-md hover:bg-accent w-full transition duration-300 font-bold"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};


export default WorkWithMe;